export default __webpack_public_path__ + "82c1417f58c9ab35181e3644324fa407.png";